var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5915 57.0068H45.3265C47.7242 57.0068 49.6314 55.0342 49.3735 52.7613C47.7085 38.1162 37.7715 38.3584 37.7715 31.8193C37.7715 25.2803 47.8356 25.6436 49.3723 10.8774C49.6145 8.60324 47.7242 6.63184 45.3265 6.63184H18.5915C16.1938 6.63184 14.3084 8.60324 14.5457 10.8774C16.0824 25.6436 26.1465 25.1592 26.1465 31.8193C26.1465 38.4795 16.2095 38.1162 14.5457 52.7613C14.2866 55.0342 16.1938 57.0068 18.5915 57.0068Z",
    stroke: "url(#paint0_linear_228_6689)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5305 53.1318H21.4396C19.5505 53.1318 19.0177 50.9521 20.3424 49.6007C23.549 46.3506 30.0215 44.0232 30.0215 40.2959V27.9443C30.0215 25.5406 25.4199 23.7061 22.573 19.8068C22.1032 19.1638 22.1504 18.2568 23.3444 18.2568H40.6281C41.6465 18.2568 41.8669 19.1566 41.4031 19.8008C38.5973 23.7061 33.8965 25.5285 33.8965 27.9443V40.2959C33.8965 43.9929 40.6426 45.9873 43.6324 49.6044C44.8373 51.0623 44.4159 53.1318 42.5305 53.1318Z",
    fill: "url(#paint1_linear_228_6689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_6689",
    x1: 49.3969,
    y1: 8.75505,
    x2: 14.5221,
    y2: 57.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5346",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_6689",
    x1: 38.2761,
    y1: 19.48,
    x2: 26.4652,
    y2: 46.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254A4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.a5376cec9e6e3d426b5da4fc5fffc281.svg";
export { ForwardRef as ReactComponent };